/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const updateSlideshowSeenStatus = createAsyncThunk(
  'updateSlideshowSeenStatus',
  async (slideshowID) => {
    console.log('Updated slideshow:', slideshowID)
    const rcpid = localStorage.getItem('rutgersEduRCPID')
    const jwtToken = localStorage.getItem('myrJwtToken')
    const res = await axios.post(
      process.env.REACT_APP_SEEN_SLIDESHOW_ENDPOINT,
      {}, // body
      {
        headers: {
          JWT: jwtToken,
          XWT: rcpid,
        },
        params: { id: slideshowID },
      },
    )

    const data = { data: res.data }

    return data
  },
)

export const fetchSlideshowScreenData = createAsyncThunk(
  'fetchSlideshowScreenData',
  async () => {
    const rcpid = localStorage.getItem('rutgersEduRCPID')
    const jwtToken = localStorage.getItem('myrJwtToken')

    const res = await axios.get(`${process.env.REACT_APP_SLIDESHOW_ENDPOINT}`, {
      headers: {
        JWT: jwtToken,
        XWT: rcpid,
      },
    })
    // console.log('Fetched slide show data:', res.data)

    const data = { data: res.data }

    return data
  },
)

const initialState = {
  status: 'idle',
  data: {
    articles: [],
  },
  error: null,
}

const slideshowScreenSlice = createSlice({
  name: 'slideshowScreen',
  initialState,
  reducers: {
    resetSlideshowData: (state) => {
      state.data = {
        articles: [],
      }
    },
  },
  extraReducers: {
    [fetchSlideshowScreenData.rejected]: (state, action) => {
      state.status = 'error'
      state.data.articles = []
      state.error = action.payload || action.error.message
    },
    [fetchSlideshowScreenData.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchSlideshowScreenData.fulfilled]: (state, action) => {
      state.status = 'fulfilled'

      state.data.articles = action.payload.data
    },
    [updateSlideshowSeenStatus.fulfilled]: (state) => {
      // CLEAR the data in Redux immediately so the UI
      // doesn't see the articles anymore.
      state.data.articles = []
      state.status = 'fulfilled'
    },
    [updateSlideshowSeenStatus.rejected]: (state) => {
      // CLEAR the data in Redux immediately so the UI
      // doesn't see the articles anymore.
      state.data.articles = []
      state.status = 'fulfilled'
    },
  },
})

export const selectSlideshowScreendata = (state) => state.slideshowScreen.data
export const selectSlideshowScreendataStatus = (state) =>
  state.slideshowScreen.status
export const selectSlideshowScreendataError = (state) =>
  state.slideshowScreen.error

export const { resetSlideshowData } = slideshowScreenSlice.actions

export default slideshowScreenSlice.reducer
